import React from 'react';
import { Badge, Nav } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { Link, Route, Switch } from "react-router-dom";
import Colors from './Colors';
import Components from './Components';
import './StyleGuide.scss';
import Typography from './Typography';

class StyleGuide extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { location, t } = this.props;

    return (
      <React.Fragment>
        <Nav className="navbar-secondary" defaultActiveKey={location.pathname} variant="tabs" bg="light">
          <Nav.Link as={Link} to="/styles" eventKey="/styles">
            {t('influencers.pages.styleguide.components')}
            <Badge variant="dark">3</Badge>
          </Nav.Link>
          <Nav.Link as={Link} to="/styles/typography" eventKey="/styles/typography">
            {t('influencers.pages.styleguide.typography')}
          </Nav.Link>
          <Nav.Link as={Link} to="/styles/colors" eventKey="/styles/colors">
            {t('influencers.pages.styleguide.colors')}
          </Nav.Link>
        </Nav>
        <Switch>
          <Route exact path="/styles" >
            <Components />
          </Route>
          <Route path="/styles/typography" component={Typography} />
          <Route path="/styles/colors" component={Colors} />
        </Switch>
      </React.Fragment>

    );
  }
}

export default withTranslation()(StyleGuide);